export var FakeParticipant;
(function (FakeParticipant) {
    FakeParticipant["LocalScreenShare"] = "LocalScreenShare";
    FakeParticipant["RemoteScreenShare"] = "RemoteScreenShare";
    FakeParticipant["SharedVideo"] = "SharedVideo";
    FakeParticipant["Whiteboard"] = "Whiteboard";
})(FakeParticipant || (FakeParticipant = {}));
